import gql from 'graphql-tag'

export const GET_INSTRUCTOR_UNAVAILABILITY = gql`
  query GetInstructorUnAvailability($InstructorId: String!){
    getInstructorUnAvailability(InstructorId: $InstructorId) {
      ServiceStatus {
        Success
        StatusCode
        Timestamp
        Message
      }
      ServiceResult {
        InstructorUnAvailabilityInfo {
          UnAvailabilityType
          TimeZone
          StartDaterTime
          Recurrance
          LearningCenterName
          LearningCenterId
          KeepExistingLessons
          InstructorProfileId
          InstructorName
          Id
          EndDateTime
          Approved
          ApprovalStatus
          AllDay
        }
      }
    }
  }
`
